import { render, staticRenderFns } from "./CoreLayoutHeadlineAndActions.vue?vue&type=template&id=7247c854&scoped=true"
var script = {}
import style0 from "./CoreLayoutHeadlineAndActions.vue?vue&type=style&index=0&id=7247c854&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7247c854",
  null
  
)

export default component.exports